import React, { useEffect, useState } from "react";
import { Box, CssBaseline, IconButton, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh.svg";
import { dashboardStyles } from "../../../assets/MUIStyles/dashboard";
import useDebounce from "../../Hooks/useDebounce";
import BaseButton from "../Common/Buttons/BaseButton";
import { PAGE_SIZE_50 } from "../CommonComponents/Common";
import {
  AddLeadsAction,
  getCeleryTasksAction,
  getLeadsDataAction,
  getSearchAction,
} from "../Projects/Store/projects.action";
import Dashboard from "./Dashboard";
import { leadDataStyles } from "../../../assets/MUIStyles/leadDataStyle";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import PageLoader from "../CommonComponents/PageLoader";

const DashboardHome = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();
  const reducer = useSelector((reducer: any) => reducer);
  const {
    ProjectReducer: { leadsList },
  } = reducer;
  const [loading, setLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [celeryData, setCeleryData] = useState<any>([]);
  const [searchedPatientIds, setSearchedPatientIds] = useState([]);
  const [patientState, setPatinetState] = useState({
    searchText: "",
    pageIndex: 1,
    filters: [{ key: "", condition: "contains", value: "" }],
  });

  const { searchText, pageIndex, filters } = patientState;
  const debouncedSearchText = useDebounce(searchText, 2000);

  const leads = {
    projectId,
    data: [
      {
        firstName: "Divyansh",
        lastName: "Sharma",
        phoneNum: "917051373005",
        dateOfSurgery: "2025-03-25",
        testResult: "Pending",
        insurance: "UnitedHealthcare #912",
      },
      {
        firstName: "Deabsmita",
        lastName: "Das",
        phoneNum: "918777253565",
      },
      {
        firstName: "Divyansh",
        lastName: "Gupta",
        phoneNum: "917051373005",
        dateOfSurgery: "2025-03-04",
        testResult: "Pending",
        insurance: "UnitedHealthcare #911",
      },
    ],
  };

  useEffect(() => {
    fetchLeadsData(!(leadsList?.length > 0));
  }, [searchedPatientIds, pageIndex]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const obj = {
        query: debouncedSearchText,
      };
      const res: any = await dispatch(getSearchAction(obj));
      setSearchedPatientIds(res?.data);
      setLoading(false);
    };

    if (debouncedSearchText) {
      getData();
    } else {
      setSearchedPatientIds([]);
    }
  }, [debouncedSearchText]);

  const fetchLeadsData = async (loading = true) => {
    setLoading(loading);
    const isDefaultEmptyFilter =
      filters.length === 1 && !filters[0].key && !filters[0].value;
    const params = {
      pageIndex,
      pageSize: PAGE_SIZE_50,
      searchtext: "",
      filterById: searchedPatientIds,
      filter: isDefaultEmptyFilter ? [] : filters,
    };
    await dispatch(getLeadsDataAction(params));
    const payload = {
      taskKey: "delayed",
      start: 0,
      end: 10000,
    };
    let resCelery = await dispatch(getCeleryTasksAction(payload));
    setCeleryData(resCelery);
    setLoading(false);
    setRefreshLoading(false);
  };

  const refreshData = async () => {
    setRefreshLoading(true);
    await fetchLeadsData(false);
  };

  const handleLeadUpload = async () => await AddLeadsAction(leads);

  const patientObj = {
    patientState,
    setPatinetState,
    celeryData,
    fetchLeadsData,
  };
  return (
    <>
      <CssBaseline />
      <Box className="flex-between gap-2">
        <Typography className="font-20-grey">Lead Dashboard</Typography>
        <IconButton
          title="Refresh"
          onClick={refreshData}
          sx={{
            ...commonStyles.refreshButtonStyle,
            ...dashboardStyles.refreshAnimation(refreshLoading),
          }}
          disabled={refreshLoading}
        >
          <RefreshIcon className="refresh-icon" height={14} width={14} />
        </IconButton>
        {/* <BaseButton
          variant="contained"
          title="Add Leads"
          handleClick={handleLeadUpload}
        /> */}
      </Box>
      {loading ? (
        <Box sx={leadDataStyles.loadingContainer}>
          <PageLoader />
        </Box>
      ) : (
        <Dashboard patientObj={patientObj} />
      )}
    </>
  );
};
export default DashboardHome;
